export default __webpack_public_path__ + "static/bridge-cf198653f89935936ca64abad45b889b.webp";